var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { refundOrderData } from "../../../reduxStore/actions/salesRepDataAction";
import { resolveRefundOrderDetailRequestParams } from "../../model/stOrderDetailsRefundGrid";
import store from "../../../reduxStore/store";
import { isLoading, salesOrderSearchText } from "../../../services/behaviorSubjectService";
export function RefundOrdersBL(columnVisibility) {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g;
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var cv = columnVisibility;
    var shopCurrency = store.getState().salesRepData.loggedInRepDetails.shopCurrency;
    var currency = store.getState().salesRepData.loggedInRepDetails.currency;
    var selectFeatures = (_a = store.getState().salesRepData.baseData.select) !== null && _a !== void 0 ? _a : {};
    var RefundOrdersHeaderNames = [
        {
            label: t("refundOrders_column1"),
            hidden: false,
        },
        {
            label: t("refundOrders_column2"),
            hidden: (cv === null || cv === void 0 ? void 0 : cv.orderDate) === false,
        },
        {
            label: t("refundOrders_column3"),
            hidden: (cv === null || cv === void 0 ? void 0 : cv.orderNumber) === false,
        },
        {
            label: t("refundOrders_column5") + "(" + shopCurrency + ")",
            hidden: (cv === null || cv === void 0 ? void 0 : cv.commission) === false,
        },
        {
            label: t("refundOrders_column6") + "(" + shopCurrency + ")",
            hidden: (cv === null || cv === void 0 ? void 0 : cv.commission) === false,
        },
        {
            label: t("refundOrders_column8") + "(" + shopCurrency + ")",
            hidden: (cv === null || cv === void 0 ? void 0 : cv.subtotal) === false,
        },
        {
            label: t("refundOrders_column9"),
            hidden: (cv === null || cv === void 0 ? void 0 : cv.status) === false,
        },
        {
            label: t("refundOrders_column10"),
            hidden: (cv === null || cv === void 0 ? void 0 : cv.salesMethod) === false,
        },
    ];
    var RefundOrdersProductHeaderNames = [
        {
            label: t("refundOrderNumber_column1"),
        },
        {
            label: t("refundOrderNumber_column3"),
        },
        {
            label: t("refundOrderNumber_column4") + "(" + shopCurrency + ")",
        },
        {
            label: t("refundOrderNumber_column5") + "(" + shopCurrency + ")",
        },
    ];
    var _h = useState((_d = (_c = (_b = store.getState().salesRepData) === null || _b === void 0 ? void 0 : _b.ordersData) === null || _c === void 0 ? void 0 : _c.allRefundOrdersDetails) !== null && _d !== void 0 ? _d : []), refundOrderArray = _h[0], setRefundOrderArray = _h[1];
    var _j = useState([]), refundOrderProductArray = _j[0], setRefundOrderProductArray = _j[1];
    var _k = useState(false), openRefundProductDataDialog = _k[0], setRefundDraftProductDataDialog = _k[1];
    var _l = useState((_g = (_f = (_e = store.getState().salesRepData) === null || _e === void 0 ? void 0 : _e.ordersData) === null || _f === void 0 ? void 0 : _f.allRefundOrdersDetails) !== null && _g !== void 0 ? _g : []), filtered = _l[0], setFiltered = _l[1];
    var _m = useState(""), searchRefundOrderText = _m[0], setSearchRefundOrderText = _m[1];
    var _o = useState({ msg: "", open: false, severity: "error" }), alertErrorMsg = _o[0], setAlertErrorMsg = _o[1];
    useEffect(function () {
        var filterTable = salesOrderSearchText.subscribe(function (data) {
            var _a, _b;
            try {
                if (data.orderTab === "Refunded" && data.searchText !== searchRefundOrderText) {
                    setSearchRefundOrderText((_a = data === null || data === void 0 ? void 0 : data.searchText) !== null && _a !== void 0 ? _a : "");
                    var searchLower_1 = ((_b = data === null || data === void 0 ? void 0 : data.searchText) !== null && _b !== void 0 ? _b : "").toLowerCase();
                    var updatedArray = Array.isArray(filtered) ? __spreadArray([], filtered, true) : [];
                    var filteredOrders = updatedArray.filter(function (order) { var _a, _b; return (_b = (_a = order === null || order === void 0 ? void 0 : order.ShopifyOrderNumber) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(searchLower_1); });
                    setRefundOrderArray(filteredOrders);
                }
            }
            catch (_c) {
                setAlertErrorMsg({ msg: t("customerInvoice_ErrorMsgTryAgain"), open: true, severity: "error" });
            }
        });
        return function () { return filterTable === null || filterTable === void 0 ? void 0 : filterTable.unsubscribe(); };
    }, [filtered, searchRefundOrderText]);
    var getRefundOrderProducts = function (item) { return __awaiter(_this, void 0, void 0, function () {
        var params, refundDataResponse, lineItems, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, 3, 4]);
                    params = resolveRefundOrderDetailRequestParams(item);
                    if (!params) {
                        setAlertErrorMsg({ msg: t("customerInvoice_ErrorMsgTryAgain"), open: true, severity: "error" });
                        return [2 /*return*/];
                    }
                    isLoading.next(true);
                    return [4 /*yield*/, dispatch(refundOrderData(params))];
                case 1:
                    refundDataResponse = _c.sent();
                    if (!refundDataResponse) {
                        setAlertErrorMsg({ msg: t("customerInvoice_ErrorMsgTryAgain"), open: true, severity: "error" });
                        return [2 /*return*/];
                    }
                    lineItems = (_b = refundDataResponse === null || refundDataResponse === void 0 ? void 0 : refundDataResponse.refunds) === null || _b === void 0 ? void 0 : _b.refund_line_items;
                    if (Array.isArray(lineItems) && lineItems.length > 0) {
                        setRefundDraftProductDataDialog(true);
                        setRefundOrderProductArray(lineItems);
                        return [2 /*return*/];
                    }
                    setAlertErrorMsg({ msg: t("noRefundOrderProduct"), open: true, severity: "error" });
                    return [3 /*break*/, 4];
                case 2:
                    _a = _c.sent();
                    setAlertErrorMsg({ msg: t("customerInvoice_ErrorMsgTryAgain"), open: true, severity: "error" });
                    return [3 /*break*/, 4];
                case 3:
                    isLoading.next(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var closeRefundProductDataDialog = function () {
        setRefundDraftProductDataDialog(false);
        setRefundOrderProductArray([]);
    };
    var handleAlertMsgClose = function () {
        setAlertErrorMsg({ msg: "", open: false, severity: "error" });
    };
    return {
        RefundOrdersHeaderNames: RefundOrdersHeaderNames,
        refundOrderArray: refundOrderArray,
        RefundOrdersProductHeaderNames: RefundOrdersProductHeaderNames,
        refundOrderProductArray: refundOrderProductArray,
        openRefundProductDataDialog: openRefundProductDataDialog,
        setRefundDraftProductDataDialog: setRefundDraftProductDataDialog,
        closeRefundProductDataDialog: closeRefundProductDataDialog,
        getRefundOrderProducts: getRefundOrderProducts,
        alertErrorMsg: alertErrorMsg,
        handleAlertMsgClose: handleAlertMsgClose,
        t: t,
        shopCurrency: shopCurrency,
        currency: currency,
        selectFeatures: selectFeatures,
    };
}
